import { render, staticRenderFns } from "./NovidadesDaVersao.vue?vue&type=template&id=40b7525a"
import script from "./NovidadesDaVersao.vue?vue&type=script&lang=js"
export * from "./NovidadesDaVersao.vue?vue&type=script&lang=js"
import style0 from "./NovidadesDaVersao.vue?vue&type=style&index=0&id=40b7525a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports